import React from 'react'
import Parallax from './Parallax'

function NotFound() {
  return (
    <div>
      <Parallax image="404" alt="Erreur 404" title="Erreur 404"/>
    </div>);

}

export default NotFound;



/** WEBPACK FOOTER **
 ** ./src/components/NotFound.js
 **/